export * from './dees-shopping-productcard.js';
